import React, { useCallback, useRef, useState } from 'react';
import {
  ChatPurchaseModal,
  FavoritesModal,
  Heading,
  Icons,
  IconSpinner,
  Modal,
} from '../../../../components';
import {
  calculateAge,
  filterSocialByHandleKey,
  formatStringtoCamelCase,
  isArrayLength,
} from '../../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import Slider from 'react-slick';
import SectionProfile from '../../Section/SectionProfile';
import ExploreServices from '../../Section/ExploreServices';
import {
  getCancellationDetailsForUnlockable,
  getDisplayName,
  getSubscriptionForListing,
  getUnlockableContentAccess,
  getUserSubscription,
  getUserSubscriptionLookupkeys,
  getUserType,
  retrieveUserFavoritesList,
} from '../../../../util/userDataExtraction';
import EnhancedServices from '../../Section/EnhancedServices';
import { useDispatch, useSelector } from 'react-redux';
import { subscriptionPlanSelector } from '../../../../ducks/stripe.duck';
import RenderUserSubscriptionMaybe from '../../../EditListingPage/EditListingWizard/EditListingTalentPlusPanel/RenderUserSubscriptionMaybe/RenderUserSubscriptionMaybe';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { createResourceLocatorString } from '../../../../util/routes';
import {
  EditListingParamsType,
  EditListingTab,
  FieldConfigKey,
  SectionHeroTabs,
  SectionTalentHeroSliderSettings,
  SUBSCRIPTION_TYPES,
  SubscriptionStatus,
  TalentLevel,
} from '../../../../util/enums';
import { useListingPageContext } from '../../context/ListingPageContext';
import { divisionOptions, divisionSchoolOptions } from '../../../../config/configExtras';
import RenderSocials from '../RenderSocials';

import css from './SectionTalentHero.module.css';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';
import { useConfiguration } from '../../../../context/configurationContext';
import SectionAffiliationLinks from './SectionAffiliationLinks';
import SectionInterests from './SectionInterests';
import TalentPlusServices from '../../Section/TalentPlusServices';
import SectionUnlockable from '../../Section/SectionUnlockable';
import { selectIsAuthenticated } from '../../../../ducks/auth.duck';
import { userSelector } from '../../../../ducks/user.duck';
import RenderTalentPlusTabs from './RenderTalentPlusTabs';
import { NilfluenceScorePageComponent } from '../../../NilfluenceScorePage/NilfluenceScorePage';
import { isMainSearchTypeKeywords } from '../../../../util/search';
import HeroTabs from './HeroTabs';
import { isScrollingDisabled } from '../../../../ducks/ui.duck';
import { DIRECT_MESSAGE } from '../../../../util/constants';
import {
  deleteItemFromFavorites,
  favoritesSelector,
} from '../../../FavoritesPage/FavoritesPage.duck';
import DirectChatSection from './DirectChatSection';
import { directChatTransactionIdSelector } from '../../ListingPage.duck';
import { createSlug } from '../../../../util/urlHelpers';
import { setListingSessionUrl } from '../../../../util/helperFunction';

const renderInfo = (label, value) => (
  <p>
    <span>
      <Icons name={formatStringtoCamelCase(label)} /> {label ? `${label}: ` : ''}
    </span>
    <span>{value || 'N/A'}</span>
  </p>
);

const SectionTalentHero = () => {
  const {
    intl,
    viewport,
    publicData,
    isMobileLayout,
    isOwnListing,
    onManageDisableScrolling,
    currentAuthor,
    listingTitle,
    listing,
    description,
    setOpenSocialSharingModal = () => {},
    onSubmitInquiry,
    history,
    routeConfiguration,
  } = useListingPageContext();
  const {
    pub_ethnicity,
    pub_sports,
    pub_jersey_number,
    pub_weight,
    pub_height,
    pub_current_town,
    pub_state,
    pub_conference,
    pub_interest,
    pub_agency,
    dateOfBirth,
    profileVideos,
    division,
    conference,
    profileDetails,
    customLinks,
    homeTownCity,
    hometownState,
    school: university,
    interest,
    affiliations,
    positions,
    currentCity,
    currentState,
    highSchoolName,
    talentPlus,
  } = publicData || {};
  const slug = createSlug(listingTitle);

  const scrollingDisabled = useSelector(isScrollingDisabled);
  const config = useConfiguration();
  const dispatch = useDispatch();
  const userFields = config.user.userFields || [];
  const ethnicityFieldConfig = userFields?.find(f => f.key === FieldConfigKey.ETHNICITY);
  const ethnicityEnumOptions = ethnicityFieldConfig?.enumOptions || [];
  const socialHandlesMaybe = profileDetails && filterSocialByHandleKey(profileDetails);
  const ethnicityLabel = ethnicityEnumOptions.find(item => item.option === pub_ethnicity)?.label;
  const params = useParams();
  const editListingRedirect = () => {
    history.push(
      createResourceLocatorString(
        'EditListingPage',
        routeConfiguration,
        { ...params, type: EditListingParamsType.EDIT, tab: EditListingTab.DETAILS },
        {}
      )
    );
  };

  const { subscriptionPrices } = useSelector(subscriptionPlanSelector);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUser = useSelector(userSelector);
  const directChatTransactionId = useSelector(directChatTransactionIdSelector);

  const [activeTab, setActiveTab] = useState(SectionHeroTabs.ABOUT);
  const [puchaseModalState, setChatPurchaseModalState] = useState(null);

  const sectionRefs = useRef({});

  const [selectedService, setSelectedService] = useState(null);
  const providerServices = publicData[selectedService] || [];
  const [activeFavoriteId, setActiveFavoriteId] = useState(null);

  const lookupKeys = getUserSubscriptionLookupkeys(currentAuthor);
  const authorDisplayName = getDisplayName(currentAuthor);
  const scrollToSection = tab => {
    const sectionRef = sectionRefs.current[tab];
    if (sectionRef) {
      sectionRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleTabClick = tab => {
    setActiveTab(tab);
    scrollToSection(tab);
    // if (tab === SectionHeroTabs.NILFLUENCE_SCORE) {
    //   history.push(createResourceLocatorString('NilfluenceScorePage', routeConfiguration, {}, {}));
    // }
  };

  const currentDivision = divisionOptions.find(o => o.key === division);

  const customAffiliations = isArrayLength(affiliations)
    ? affiliations?.map(aff => aff?.organization)
    : [];

  const conferenceOption =
    divisionSchoolOptions.find(option => option?.conference === conference) || {};

  const talentLevel = publicData?.pub_talent_level;
  const talentType = publicData?.pub_talent_type;
  const userType = getUserType(listing?.author);

  const sportsMaybe = isArrayLength(positions)
    ? positions.map(p => p?.sport).join(', ')
    : pub_sports?.[0]?.label;

  const authorId = currentAuthor?.id?.uuid;
  const listingId = listing?.id?.uuid;
  const talentPlusMaybe = Boolean(
    getUserSubscription(listing?.author) === SUBSCRIPTION_TYPES.TALENT_PLUS
  );
  const currentUserSubscription = getSubscriptionForListing(currentUser, listingId);
  const isCurrentUserTalentPlus =
    getUserSubscription(currentUser) === SUBSCRIPTION_TYPES.TALENT_PLUS;

  const isCurrentUserSubscriptionActive =
    isArrayLength(currentUserSubscription) &&
    currentUserSubscription?.some(sub => sub.status === SubscriptionStatus.ACTIVE);
  const isHighSchool = talentLevel === TalentLevel.HIGH_SCHOOL;
  const isCollegiate = talentLevel === TalentLevel.COLLEGIATE;

  const affiliationsOptions = [
    ...(pub_agency?.id ? [pub_agency] : []),
    ...(isCollegiate ? [conferenceOption, currentDivision] : []),
    ...customAffiliations,
  ]?.filter(Boolean);
  const isTalentPlusTab = activeTab === SectionHeroTabs.TALENT_PLUS;
  const isUnlockableContentTab = activeTab === SectionHeroTabs.UNLOCKABLE_CONTENT;

  const hasAccess = isOwnListing || (isAuthenticated && isCurrentUserSubscriptionActive);

  const shouldShowTalentPlusServices = hasAccess && isTalentPlusTab;
  const shouldShowUnlockableContent = isUnlockableContentTab;

  const shouldShowTalentBanner =
    !isOwnListing &&
    (!isAuthenticated || !isCurrentUserSubscriptionActive) &&
    [SectionHeroTabs.TALENT_PLUS].includes(activeTab);
  const isDirectMessage =
    isArrayLength(talentPlus) &&
    talentPlus?.some(item => item?.selected === true && item?.type === DIRECT_MESSAGE);
  const directMessageService =
    isArrayLength(talentPlus) &&
    talentPlus?.find(item => item?.selected === true && item?.type === DIRECT_MESSAGE);
  const firstImage = isArrayLength(listing?.images) ? listing.images[0] : null;
  const openFavoritesModal = id => setActiveFavoriteId(id);
  const currentUserId = currentUser?.id?.uuid;
  const favorites = retrieveUserFavoritesList(currentUser) || [];
  const { removedItemId } = useSelector(favoritesSelector);
  const favoritesList = favorites || [];
  const isAlreadyAddedToFavoriteslist =
    isArrayLength(favoritesList) &&
    favoritesList.some(category => category.ids?.includes(listingId));

  const navigateToLogin = () => {
    history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}));
    setListingSessionUrl(
      createResourceLocatorString('ListingPage', routeConfiguration, { slug, id: listingId }, {})
    );
  };
  const handleFavoritesList = useCallback(
    async e => {
      e.preventDefault();
      e.stopPropagation();

      try {
        if (!isAuthenticated) {
          navigateToLogin();
        }
        if (isOwnListing) {
          history.push(createResourceLocatorString('FavoritesPage', routeConfiguration, {}));
          return;
        }

        if (isAlreadyAddedToFavoriteslist) {
          await dispatch(
            deleteItemFromFavorites({
              isAuthenticated,
              id: listingId,
              favorites,
              config,
              userId: currentUserId,
            })
          );
        } else {
          openFavoritesModal(listingId);
        }
      } catch (error) {}
    },
    [
      isOwnListing,
      isAlreadyAddedToFavoriteslist,
      history,
      routeConfiguration,
      dispatch,
      listingId,
      favorites,
      config,
      currentUserId,
      openFavoritesModal,
    ]
  );

  // Check if unlockable content is enabled with fallback
  const { hasUnlockableContentAccess = false } = getUnlockableContentAccess(
    currentUserSubscription,
    subscriptionPrices
  );
  const { willCancelAtPeriodEnd, cancellationDateUnix } = getCancellationDetailsForUnlockable(
    currentUserSubscription,
    subscriptionPrices
  );
  const showTalentPlus = isTalentPlusTab && isCurrentUserSubscriptionActive;
  return (
    <div className={css.heroWrapper}>
      <div className={css.heroContainer}>
        <div className={css.heroBg}>
          <div className={css.contentWidth}>
            <div className={css.heroContent}>
              <div className={css.heroContentHead}>
                <div className={css.heroContentHeadLeft}>
                  {isArrayLength(listing?.images) &&
                    listing?.images.slice(0, 1)?.map((img, index) => {
                      const imgUrl = img?.attributes?.variants['square-small2x']?.url;
                      return (
                        <div className={css.schoolImg} key={index}>
                          <img
                            src={imgUrl}
                            alt={`Featured ${index + 1}`}
                            className={css.featuredImage}
                          />
                        </div>
                      );
                    })}

                  <Heading as="h1" rootClassName={css.heading}>
                    {listingTitle}
                  </Heading>
                  <div className={css.verifySec}>
                    <Icons name="verify" /> <FormattedMessage id="BrandListingCard.verified" />
                    {talentPlusMaybe
                      ? SUBSCRIPTION_TYPES.TALENT_PLUS
                      : SUBSCRIPTION_TYPES.TALENT_STANDARD}
                  </div>
                </div>
                <div className={css.heroContentHeadRight}>
                  <RenderSocials socialHandlesMaybe={socialHandlesMaybe} />
                  {description && (
                    <div className={css.aboutInfo}>
                      <p>{description}</p>
                    </div>
                  )}

                  <div className={css.bookSessionSec}>
                    <div className={css.contactSec}>
                      <button
                        type="button"
                        className={isAlreadyAddedToFavoriteslist ? css.favorited : null}
                        onClick={handleFavoritesList}
                      >
                        {removedItemId === listingId ? <IconSpinner /> : <Icons name="star" />}{' '}
                        <FormattedMessage id="SectionHero.favorite" />
                      </button>

                      {isDirectMessage && (
                        <DirectChatSection
                          directMessageService={directMessageService}
                          currentUser={currentUser}
                          listingId={listingId}
                          directChatTransactionId={directChatTransactionId}
                          routeConfiguration={routeConfiguration}
                          history={history}
                          listing={listing}
                          isAuthenticated={isAuthenticated}
                          navigateToLogin={navigateToLogin}
                          setChatPurchaseModalState={setChatPurchaseModalState}
                        />
                      )}
                      <button type="button" onClick={() => setOpenSocialSharingModal(true)}>
                        <Icons name="share" /> Share
                      </button>
                    </div>
                  </div>
                  <div className={css.schoolInfo}>
                    <div className={css.otherDetails}>
                      {[TalentLevel.HIGH_SCHOOL, TalentLevel.COLLEGIATE].includes(talentLevel) && (
                        <p>
                          <span>
                            <Icons name="university" />
                            <FormattedMessage
                              id={isHighSchool ? 'SectionHero.highSchool' : 'SectionHero.school'}
                            />
                          </span>
                          <span>{isHighSchool ? highSchoolName : university}</span>
                        </p>
                      )}
                      {renderInfo('Age', `${calculateAge(dateOfBirth)} years`)}
                      {renderInfo('Sports', sportsMaybe)}
                      {[TalentLevel.HIGH_SCHOOL, TalentLevel.COLLEGIATE].includes(talentLevel) &&
                        renderInfo('Conference', conference || pub_conference)}
                      {renderInfo('Jersey Number', `#${pub_jersey_number}`)}
                      {renderInfo('Height', `${pub_height?.feet}'${pub_height?.inches}''`)}
                      {renderInfo('Weight', `${pub_weight} lbs`)}
                    </div>
                    <div className={css.address}>
                      {renderInfo(
                        'Current Town',
                        [currentCity, currentState].filter(Boolean).join(', ')
                      )}
                      {renderInfo(
                        'Home Town',
                        [homeTownCity, hometownState].filter(Boolean).join(', ')
                      )}
                      {pub_ethnicity && renderInfo('Ethnicity', ethnicityLabel)}
                    </div>
                  </div>
                </div>
              </div>
              {isArrayLength(positions) && (
                <div className={css.keywordSec}>
                  <h2>
                    <FormattedMessage id="SectionHero.positions" />
                  </h2>
                  <div className={css.keywords}>
                    {positions.map((i, index) => (
                      <span key={index} className={css.positionItem}>
                        <strong>
                          {i?.sport} | Position: {i?.position}
                        </strong>
                      </span>
                    ))}
                  </div>
                </div>
              )}
              <SectionInterests pub_interest={pub_interest} interest={interest} />
              <SectionAffiliationLinks affiliationsOptions={affiliationsOptions} />

              {isArrayLength(customLinks) && talentPlusMaybe && (
                <div className={css.keywordSec}>
                  <h2>
                    <FormattedMessage id="SectionHero.customLinks" />
                  </h2>
                  <div className={css.keywords}>
                    {customLinks.map((link, index) => (
                      <span key={index}>
                        <strong>
                          <a href={link?.url} target="_blank" rel="noopener noreferrer">
                            {link?.name}
                          </a>
                        </strong>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className={css.heroContentImg}>
              <HeroTabs
                isOwnListing={isOwnListing}
                isCurrentUserSubscriptionActive={isCurrentUserSubscriptionActive}
                talentPlusMaybe={talentPlusMaybe}
                activeTab={activeTab}
                handleTabClick={handleTabClick}
                editListingRedirect={editListingRedirect}
              />
              {shouldShowTalentBanner && (
                <div className={css.talentBanner}>
                  <FormattedMessage
                    id="SectionHero.talentBanner.message"
                    values={{ talentName: <strong>{listingTitle}</strong> }}
                  />
                </div>
              )}
              {activeTab === SectionHeroTabs.NILFLUENCE_SCORE && (
                <NilfluenceScorePageComponent
                  routeConfiguration={routeConfiguration}
                  marketplaceName={config.marketplaceName}
                  isKeywordSearch={isMainSearchTypeKeywords(config)}
                  history={history}
                  intl={intl}
                  hideSomeSections={true}
                  scrollingDisabled={scrollingDisabled}
                />
              )}
              {shouldShowTalentPlusServices && (
                <TalentPlusServices
                  isMobileLayout={isMobileLayout}
                  intl={intl}
                  viewport={viewport}
                  publicData={publicData}
                  onSelectService={setSelectedService}
                />
              )}
              {shouldShowUnlockableContent && (
                <SectionUnlockable
                  isMobileLayout={isMobileLayout}
                  intl={intl}
                  viewport={viewport}
                  publicData={publicData}
                  onSelectService={s => setSelectedService(s)}
                  listing={listing}
                  routeConfiguration={routeConfiguration}
                  history={history}
                  isOwnListing={isOwnListing}
                  isCurrentUserSubscriptionActive={isCurrentUserSubscriptionActive}
                  hasUnlockableContentAccess={hasUnlockableContentAccess}
                  cancellationDateUnix={cancellationDateUnix}
                  willCancelAtPeriodEnd={willCancelAtPeriodEnd}
                />
              )}
              {[SectionHeroTabs.ABOUT].includes(activeTab) && (
                <>
                  <Slider
                    {...{
                      ...SectionTalentHeroSliderSettings,
                    }}
                  >
                    {isArrayLength(listing?.images) &&
                      listing?.images?.map((img, index) => {
                        const imgUrl = img?.attributes?.variants['square-small2x']?.url;
                        return (
                          <div className={css.heroContentImgBlock} key={index}>
                            <img
                              src={imgUrl}
                              alt={`Featured ${index + 1}`}
                              className={css.featuredImage}
                            />
                          </div>
                        );
                      })}
                  </Slider>
                  {isOwnListing && !isCurrentUserTalentPlus && (
                    <div className={css.talentBanner}>
                      <h4>
                        <FormattedMessage id="SectionHero.talentPlus.headingBanner" />
                      </h4>
                      <FormattedMessage id="SectionHero.talentPlus.standardBanner" />
                    </div>
                  )}

                  {activeTab === SectionHeroTabs.ABOUT && (
                    <>
                      <ExploreServices
                        isMobileLayout={isMobileLayout}
                        intl={intl}
                        viewport={viewport}
                        publicData={publicData}
                        onSelectService={s => setSelectedService(s)}
                      />
                      <EnhancedServices
                        isMobileLayout={isMobileLayout}
                        intl={intl}
                        viewport={viewport}
                        publicData={publicData}
                        onSelectService={s => setSelectedService(s)}
                      />
                    </>
                  )}
                </>
              )}
              {isArrayLength(subscriptionPrices) && activeTab === SectionHeroTabs.SUBCRIPTIONS && (
                <div className={css.howItWorks}>
                  <div className={css.sectionHead}>
                    <div className={css.leftSec}>
                      <h2>{intl.formatMessage({ id: 'SectionHero.subscriptionHeading' })}</h2>
                    </div>
                  </div>

                  <RenderUserSubscriptionMaybe
                    lookupKeys={lookupKeys}
                    subscriptions={subscriptionPrices}
                    isListingPage={true}
                    isOwnListing={isOwnListing}
                    sectionRef={el => (sectionRefs.current[SectionHeroTabs.SUBCRIPTIONS] = el)}
                    authorId={authorId}
                    listingId={listingId}
                    currentUserSubscription={currentUserSubscription}
                  />
                </div>
              )}
              {/* {isArrayLength(profileVideos) && activeTab === SectionHeroTabs.VIDEOS && (
                <SectionProfileVideos
                  profileVideos={profileVideos}
                  sectionRef={el => (sectionRefs.current[SectionHeroTabs.VIDEOS] = el)}
                />
              )} */}
              {showTalentPlus ? (
                <RenderTalentPlusTabs
                  isMobileLayout={isMobileLayout}
                  intl={intl}
                  viewport={viewport}
                />
              ) : null}
              <Modal
                className={css.renderTalentServicesModal}
                id="RenderTalentModal"
                isOpen={!!selectedService}
                onClose={() => setSelectedService(null)}
                onManageDisableScrolling={onManageDisableScrolling}
              >
                <SectionProfile
                  intl={intl}
                  listing={listing}
                  listingTitle={listingTitle}
                  currentAuthor={currentAuthor}
                  providerServices={providerServices}
                  selectedService={selectedService}
                  isTalentProfileModalContent={true}
                />
              </Modal>
              <FavoritesModal
                isOpen={!!activeFavoriteId}
                onClose={() => setActiveFavoriteId(null)}
                firstImage={firstImage}
                currentUserId={currentUserId}
                activeFavoriteId={activeFavoriteId}
              />
              <ChatPurchaseModal
                isOpen={!!puchaseModalState?.priceAmount}
                puchaseModalState={puchaseModalState}
                onClose={() => setChatPurchaseModalState(false)}
                setChatPurchaseModalState={setChatPurchaseModalState}
                listing={listing}
                authorDisplayName={authorDisplayName}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTalentHero;
